import { IUserReplacement } from "@/interfaces";
import { Space, Switch, Typography } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

interface ISetNotApplicableToggleProps {
  selectedRowsData: IUserReplacement[];
  naToggleValue: boolean;
  handleNaToggle: (checked: boolean) => void;
}

export const SetNotApplicableToggle = ({
  selectedRowsData,
  naToggleValue,
  handleNaToggle,
}: ISetNotApplicableToggleProps) => {
  const intl = useIntl();
  const [toggleVisible, setToggleVisible] = useState(false);

  //On data & selection changes, recalculate if set n/a appears
  useEffect(() => {
    const foundNaNotEligible =
      selectedRowsData?.length > 0 &&
      selectedRowsData.every(
        (row) => row?.isProjectHeader || row?.notApplicableEligible
      );

    setToggleVisible(foundNaNotEligible);

    if (!foundNaNotEligible) {
      handleNaToggle(false);
    }
  }, [selectedRowsData, handleNaToggle]);

  return (
    toggleVisible && (
      <Space>
        <Typography.Text strong>
          {intl.formatMessage({
            id: "userReplacement.setNotApplicable",
          })}
        </Typography.Text>
        <Switch
          checked={naToggleValue}
          data-test-id={`user-replace-set-na-switch`}
          checkedChildren={intl.formatMessage({
            id: "general.yes",
          })}
          unCheckedChildren={intl.formatMessage({
            id: "general.no",
          })}
          onClick={(checked) => handleNaToggle(checked)}
        />
      </Space>
    )
  );
};
